import { render, staticRenderFns } from "./LocationMenus.vue?vue&type=template&id=367b8994"
import script from "./LocationMenus.vue?vue&type=script&lang=js"
export * from "./LocationMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports